import { createReducer, on } from '@ngrx/store';
import { Role } from '@app/store/shared/models';
import { ROWS_PER_PAGE } from '@shared/components';
import { rolesActions } from '../actions/roles.actions';
import { GetRolesValue, RoleLookup } from '../models';

export interface RolesState {
    loaded: boolean | null;
    loading: boolean;
    roles: Role[];
    // The last list request, replayed to refresh the list after a delete.
    query: GetRolesValue;
    total: number;
    lookupLoaded: boolean | null;
    lookup: RoleLookup[];
}

export const initialState: RolesState = {
    loaded: null,
    loading: false,
    roles: [],
    query: { page: 1, limit: ROWS_PER_PAGE[0] },
    total: 0,
    lookupLoaded: null,
    lookup: [],
};

export const rolesReducer = createReducer(
    initialState,
    on(rolesActions.getRoles, (state, { value }): RolesState => ({
        ...state,
        query: value,
        loading: true,
    })),
    on(rolesActions.getRolesSuccess, (state, { payload }): RolesState => ({
        ...state,
        loading: false,
        loaded: true,
        roles: payload.items,
        total: payload.total,
    })),
    on(rolesActions.getRolesError, (state): RolesState => ({
        ...state,
        loading: false,
        loaded: false,
    })),
    // Lookup - a loaded one stays loaded while it refetches, so a revisited form shows its options at once; a failed one goes back to pending.
    on(rolesActions.getRolesLookup, (state): RolesState => ({
        ...state,
        lookupLoaded: state.lookupLoaded || null,
    })),
    on(rolesActions.getRolesLookupSuccess, (state, { payload }): RolesState => ({
        ...state,
        lookupLoaded: true,
        lookup: payload,
    })),
    on(rolesActions.getRolesLookupError, (state): RolesState => ({
        ...state,
        lookupLoaded: false,
    })),
    on(rolesActions.clear, (): RolesState => ({ ...initialState })),
);
